import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import img1 from '../assets/images/imgs/Brands and partners 1.jpg'
import { Link, useNavigate } from "react-router-dom";
import kfmb from '../assets/images/kfmb.svg';
import kfmb2 from '../assets/images/kfmb2.svg';
import efr from '../assets/images/efr.svg';
import efr2 from '../assets/images/efr2.svg';
import seed from '../assets/images/seed.svg';
import seed2 from '../assets/images/seed2.svg';
import tesla from '../assets/images/tesla.svg';
import tesla2 from '../assets/images/tesla2.svg';
import pandy from '../assets/images/pandy.svg'
import pandy2 from '../assets/images/pandy2.svg'
import lfc from '../assets/images/imgs/lfc2.png'
import lfc2 from '../assets/images/lfc2.svg'
import impact from '../assets/images/imgs/impact.png'
import impact2 from '../assets/images/imgs/impact2.png'
import cates from '../assets/images/cates.webp'
import kfmbbg from '../assets/images/bgimgs/kfmb.jpg';
import pandybg from '../assets/images/bgimgs/pandy.jpg';
import efrbg from '../assets/images/bgimgs/erf.jpg';
import impactbg from '../assets/images/bgimgs/impact.jpg';
import lfcbg from '../assets/images/bgimgs/lfc.jpg';
import teslabg from '../assets/images/bgimgs/tesla.jpg';
import seedbg from '../assets/images/bgimgs/seedawi.jpg';
import seclimg from '../assets/images/bgimgs/seclimg.jpg'
import trillo from '../assets/images/trillo.png'
import trillo2 from '../assets/images/trillo3.jpg'
import wrapmaster from '../assets/images/wrapmaster.png'
import wrapmaster2 from '../assets/images/wrapmaster2.jpg'
import goldenshine from '../assets/images/goldenshine.png'
import goldenshine2 from '../assets/images/goldenshine2.jpg'
import { CircularProgress } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export default function Brands() {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [inquired, setInquired] = useState(false)

    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('brands');
    }, [])

    const [kfmbHovered, setKFMBHovered] = useState(false)
    const [efrHovered, setEFRHovered] = useState(false)
    const [seedHovered, setSeedHovered] = useState(false)
    const [teslaHovered, setTeslaHovered] = useState(false)
    const [pandyHovered, setPandyHovered] = useState(false)
    const [lfcHovered, setLfcHovered] = useState(false)
    const [impactHovered, setImpactHovered] = useState(false)


    async function sendEmails(e) {
        if (!name || !phone) {
            return;
        }
        e.preventDefault()
        setLoading(true)
        try {
            await fetch('https://igtmail.netlify.app/.netlify/functions/igtmail', {
                method: 'POST',
                body: JSON.stringify({
                    // to: 'admin@devozilla.com',
                    to: 'moussa@intgroupuae.com',
                    subject: 'New Partner Inquiry',
                    text: `A new partner inquiry has been submitted on the website.
                        Data:
                        name: ${name}
                        phone: ${phone}
                    `,
                    html: `<h1>A new partner inquiry has been submitted on the website.</h1>
                        <h2>Data:</h2>
                        <ul> <li>name: ${name}</li> 
                        <li>phone: ${phone}</li> </ul>`
                }),
            });
            setName('')
            setPhone('')
            setInquired(true)
        } catch (error) {
            console.error("Error sending emails:", error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            {loading && <div className='bkdrop' style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 99999999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}><CircularProgress sx={{ color: '#fff' }} /></div>}
            {inquired && <div onClick={() => setInquired(false)} className='bkdrop' style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 99999999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <div style={{
                    padding: '20px',
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0px 0px 10px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '20px',
                    maxWidth: '450px'
                }}>
                    <CheckCircleOutlineIcon sx={{
                        width: '100px',
                        height: '100px',
                        color: 'green'
                    }} />
                    <h2 style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        fontFamily: 'Playfair, sans-serif'
                    }}>{t('inquiry_sent')}</h2>
                </div>
            </div>}
            <div id="content" className="nc">
                <section className="flex flex-col items-center min-h-screen justify-center p-[20px] lg:p-[100px] gap-[50px] lg:gap-[10px]">
                    <div className="flex flex-col lg:flex-row gap-[150px]">
                        <div className="flex flex-col gap-[50px] py-[10px]">
                            <h2 className="is-slideup text-xl lg:text-5xl capitalize font-black">{t('brands_desc')} <span className="font-thin">{t('brands_desc1')}</span> {t('brands_desc2')}</h2>
                            <h3 className="text-lg lg:text-3xl capitalize">{t('partners_desc')}</h3>
                        </div>
                        <div className="min-w-full md:min-w-[500px] lg:min-w-[700px]">
                            <img className="w-full lg:w-[700px]" src={img1} alt="" />
                        </div>
                    </div>
                    <Link to='/contact' className="text-white underline underline-offset-[5px] nbg p-[8px] rounded-full px-[20px] text-lg hover:bg-[#D0A847] hover:text-[#201B57] transition-all duration-[.3s]">{t('sign_up')}</Link>
                </section>

                <section className="py-[20px]">
                    <div className="flex flex-wrap p-[10px] lg:p-[50px] gap-[50px] lg:gap-[100px] justify-center">
                        <div className="w-full xl:w-1/4 gap-[5px] flex border-[.5px] border-[#D0A847] rounded-[30px] p-[40px] nc">
                            <h2>{t('number_01')}</h2>
                            <span className="flex flex-col gap-[10px]">
                                <h2 className="font-black text-xl">{t('safety_standards')}</h2>
                                <h3 className="text-lg">{t('safety_standards_desc')}</h3>
                            </span>
                        </div>
                        <div className="w-full xl:w-1/4 gap-[5px] flex border-[.5px] border-[#D0A847] rounded-[30px] p-[40px] nc">
                            <h2>{t('number_02')}</h2>
                            <span className="flex flex-col gap-[10px]">
                                <h2 className="font-black text-xl">{t('eco_friendly')}</h2>
                                <h3 className="text-lg">{t('eco_friendly_desc')}</h3>
                            </span>
                        </div>
                        <div className="w-full xl:w-1/4 gap-[5px] flex border-[.5px] border-[#D0A847] rounded-[30px] p-[40px] nc">
                            <h2>{t('number_03')}</h2>
                            <span className="flex flex-col gap-[10px]">
                                <h2 className="font-black text-xl">{t('digital_tech')}</h2>
                                <h3 className="text-lg">{t('digital_tech_desc')}</h3>
                            </span>
                        </div>
                    </div>
                </section>

                <section className="flex flex-col items-center gap-[20px] py-[20px] lg:py-[100px] min-h-screen">
                    <h1 className="is-slideup text-lg font-black capitalize lg:text-3xl 2xl:text-4xl text-center">{t('discover_diverse_range')}</h1>
                    <h2 className="text-[#D0A847] text-md font-thin capitalize lg:text-xl 2xl:text-2xl text-center">{t('igt_commitment')}</h2>
                    <div className="flex flex-wrap px-[10px] lg:px-[50px] gap-[20px] lg:gap-[50px] mb-[20px] justify-center">
                        <div onClick={() => navigate('/brands/kfmb')} onMouseEnter={() => setKFMBHovered(true)} onMouseLeave={() => setKFMBHovered(false)} className="w-full xl:w-[350px] gap-0 flex flex-col justify-end items-center border-[2px] overflow-hidden border-[#D0A847] rounded-[20px] nc cursor-pointer group">
                            <div className="relative w-full flex justify-center items-center bg-white h-[180px] overflow-hidden">
                                <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-30' style={{ backgroundImage: `url(${kfmbbg})` }}></div>
                                <img src={kfmbHovered ? kfmb2 : kfmb} className="w-[150px] m-[20px] relative z-10" alt="" />
                            </div>
                            <span className="flex flex-col gap-[10px] h-[120px] p-[20px] bg-[#E8E3DF] w-full">
                                <h2 className="font-black text-xl text-center">{t('partner1_name')}</h2>
                                <h3 className="text-sm text-center">{t('partner1_desc')}</h3>
                            </span>
                        </div>
                        <div onClick={() => navigate('/brands/egyptian-rice')} onMouseEnter={() => setEFRHovered(true)} onMouseLeave={() => setEFRHovered(false)} className="w-full xl:w-[350px] gap-0 flex flex-col justify-end items-center border-[2px] overflow-hidden border-[#D0A847] rounded-[20px] nc cursor-pointer group">
                            <div className="relative w-full flex justify-center items-center bg-white h-[180px] overflow-hidden">
                                <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-30' style={{ backgroundImage: `url(${efrbg})` }}></div>
                                <img src={efrHovered ? efr2 : efr} className="w-[150px] m-[20px] relative z-10" alt="" />
                            </div>
                            <span className="flex flex-col gap-[10px] h-[120px] p-[20px] bg-[#E8E3DF] w-full">
                                <h2 className="font-black text-xl text-center">{t('partner2_name')}</h2>
                                <h3 className="text-sm text-center">{t('partner2_desc')}</h3>
                            </span>
                        </div>
                        <div onClick={() => navigate('/brands/seedawi')} onMouseEnter={() => setSeedHovered(true)} onMouseLeave={() => setSeedHovered(false)} className="w-full xl:w-[350px] gap-0 flex flex-col justify-end items-center border-[2px] overflow-hidden border-[#D0A847] rounded-[20px] nc cursor-pointer group">
                            <div className="relative w-full flex justify-center items-center bg-white h-[180px] overflow-hidden">
                                <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-30' style={{ backgroundImage: `url(${seedbg})` }}></div>
                                <img src={seedHovered ? seed2 : seed} className="w-[150px] m-[20px] relative z-10" alt="" />
                            </div>
                            <span className="flex flex-col gap-[10px] h-[120px] p-[20px] bg-[#E8E3DF] w-full">
                                <h2 className="font-black text-xl text-center">{t('partner3_name')}</h2>
                                <h3 className="text-sm text-center">{t('partner3_desc')}</h3>
                            </span>
                        </div>
                    </div>
                    <div className="flex flex-wrap px-[10px] lg:px-[50px] gap-[20px] lg:gap-[50px] mb-[20px] justify-center">
                        <div onClick={() => navigate('/brands/trillo')} onMouseEnter={() => setTeslaHovered(true)} onMouseLeave={() => setTeslaHovered(false)} className="w-full xl:w-[350px] gap-0 flex flex-col justify-end items-center border-[2px] overflow-hidden border-[#D0A847] rounded-[20px] nc cursor-pointer group">
                            <div className="relative w-full flex justify-center items-center bg-white h-[180px] overflow-hidden">
                                <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-30' style={{ backgroundImage: `url(${trillo2})` }}></div>
                                <img src={teslaHovered ? trillo : trillo} className="w-[150px] m-[50px] relative z-10" alt="" />
                            </div>
                            <span className="flex flex-col gap-[10px] h-[120px] p-[20px] bg-[#E8E3DF] w-full">
                                <h2 className="font-black text-xl text-center">{t('trillo')}</h2>
                                <h3 className="text-sm text-center">{t('trillo_desc')}</h3>
                            </span>
                        </div>
                        <div onClick={() => navigate('/brands/wrap-master')} onMouseEnter={() => setPandyHovered(true)} onMouseLeave={() => setPandyHovered(false)} className="w-full xl:w-[350px] gap-0 flex flex-col justify-end items-center border-[2px] overflow-hidden border-[#D0A847] rounded-[20px] nc cursor-pointer group">
                            <div className="relative w-full flex justify-center items-center bg-white h-[180px] overflow-hidden">
                                <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-30' style={{ backgroundImage: `url(${wrapmaster2})` }}></div>
                                <img src={pandyHovered ? wrapmaster : wrapmaster} className="w-[150px] m-[40px] relative z-10" alt="" />
                            </div>
                            <span className="flex flex-col gap-[10px] h-[120px] p-[20px] bg-[#E8E3DF] w-full">
                                <h2 className="font-black text-xl text-center">{t('wrap_master')}</h2>
                                <h3 className="text-sm text-center">{t('wrap_master_desc')}</h3>
                            </span>
                        </div>
                        <div onClick={() => navigate('/brands/golden-shine')} onMouseEnter={() => setLfcHovered(true)} onMouseLeave={() => setLfcHovered(false)} className="w-full xl:w-[350px] gap-0 flex flex-col justify-end items-center border-[2px] overflow-hidden border-[#D0A847] rounded-[20px] nc cursor-pointer group">
                            <div className="relative w-full flex justify-center items-center bg-white h-[180px] overflow-hidden">
                                <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-30' style={{ backgroundImage: `url(${goldenshine2})` }}></div>
                                <img src={lfcHovered ? goldenshine : goldenshine} className="w-[150px] m-[40px] relative z-10" alt="" />
                            </div>
                            <span className="flex flex-col gap-[10px] h-[120px] p-[20px] bg-[#E8E3DF] w-full">
                                <h2 className="font-black text-xl text-center">{t('golden_shine')}</h2>
                                <h3 className="text-sm text-center">{t('golden_shine')}</h3>
                            </span>
                        </div>
                    </div>
                    {/* <div className="flex flex-wrap px-[10px] lg:px-[50px] gap-[20px] lg:gap-[50px] mb-[20px] justify-center">
                        <div onClick={() => navigate('/brands/tesla')} onMouseEnter={() => setTeslaHovered(true)} onMouseLeave={() => setTeslaHovered(false)} className="w-full xl:w-[350px] gap-0 flex flex-col justify-end items-center border-[2px] overflow-hidden border-[#D0A847] rounded-[20px] nc cursor-pointer group">
                            <div className="relative w-full flex justify-center items-center bg-white h-[180px] overflow-hidden">
                                <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-30' style={{ backgroundImage: `url(${teslabg})` }}></div>
                                <img src={teslaHovered ? tesla2 : tesla} className="w-[150px] m-[50px] relative z-10" alt="" />
                            </div>
                            <span className="flex flex-col gap-[10px] h-[120px] p-[20px] bg-[#E8E3DF] w-full">
                                <h2 className="font-black text-xl text-center">{t('tesla_brand')}</h2>
                                <h3 className="text-sm text-center">{t('tesla_desc')}</h3>
                            </span>
                        </div>
                        <div onClick={() => navigate('/brands/pandy')} onMouseEnter={() => setPandyHovered(true)} onMouseLeave={() => setPandyHovered(false)} className="w-full xl:w-[350px] gap-0 flex flex-col justify-end items-center border-[2px] overflow-hidden border-[#D0A847] rounded-[20px] nc cursor-pointer group">
                            <div className="relative w-full flex justify-center items-center bg-white h-[180px] overflow-hidden">
                                <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-30' style={{ backgroundImage: `url(${pandybg})` }}></div>
                                <img src={pandyHovered ? pandy2 : pandy} className="w-[150px] m-[40px] relative z-10" alt="" />
                            </div>
                            <span className="flex flex-col gap-[10px] h-[120px] p-[20px] bg-[#E8E3DF] w-full">
                                <h2 className="font-black text-xl text-center">{t('pandy_brand')}</h2>
                                <h3 className="text-sm text-center">{t('pandy_short_desc')}</h3>
                            </span>
                        </div>
                        <div onClick={() => navigate('/brands/lfc')} onMouseEnter={() => setLfcHovered(true)} onMouseLeave={() => setLfcHovered(false)} className="w-full xl:w-[350px] gap-0 flex flex-col justify-end items-center border-[2px] overflow-hidden border-[#D0A847] rounded-[20px] nc cursor-pointer group">
                            <div className="relative w-full flex justify-center items-center bg-white h-[180px] overflow-hidden">
                                <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-30' style={{ backgroundImage: `url(${lfcbg})` }}></div>
                                <img src={lfcHovered ? lfc2 : lfc} className="w-[100px] max-w-[100px] m-[20px] relative z-10" alt="" />
                            </div>
                            <span className="flex flex-col gap-[10px] h-[120px] p-[20px] bg-[#E8E3DF] w-full">
                                <h2 className="font-black text-xl text-center">{t('lfc_brand')}</h2>
                                <h3 className="text-sm text-center">{t('lfc_short_desc')}</h3>
                            </span>
                        </div>
                    </div> */}
                    {/* <div className="flex flex-wrap px-[10px] lg:px-[50px] gap-[50px] lg:gap-[50px] justify-center">
                    <div onClick={() => navigate('/brands/impact')} onMouseEnter={() => setImpactHovered(true)} onMouseLeave={() => setImpactHovered(false)} className="w-full xl:w-[350px] gap-0 flex flex-col justify-end items-center border-[2px] overflow-hidden border-[#D0A847] rounded-[20px] nc cursor-pointer group">
                        <div className="relative w-full flex justify-center items-center bg-white h-[180px] overflow-hidden">
                            <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-opacity duration-300' style={{ backgroundImage: `url(${impactbg})` }}></div>
                            <img src={impactHovered ? impact2 : impact} className="w-[150px] m-[50px] relative z-10" alt="" />
                        </div>
                        <span className="flex flex-col gap-[10px] h-[120px] p-[20px] bg-[#E8E3DF] w-full">
                            <h2 className="font-black text-xl text-center">{t('impact_brand')}</h2>
                        </span>
                    </div>
                </div> */}
                </section>

                <section className="py-[20px]">
                    <div className="p-[50px]">
                        <h1 className="text-center is-slideup text-xl lg:text-2xl 2xl:text-4xl capitalize">{t('partners_testimonials')}</h1>
                    </div>
                    <div className="flex flex-col lg:flex-row justify-center gap-[50px] lg:gap-[150px]">
                        <div className="max-w-full lg:max-w-[400px] flex flex-col gap-[30px] relative p-[20px]">
                            <span className="absolute right-[0px] lg:right-[-40px] top-[-40px] text-8xl text-[#D0A847] font-black">"</span>
                            <h2 className="text-justify">
                                {t('testimonial1')}
                            </h2>
                            <div className="flex items-center gap-[20px]">
                                <img src={cates} className="max-w-[80px]" alt="" />
                                <span>{t('team_monga')}</span>
                            </div>
                        </div>
                        <div className="max-w-full lg:max-w-[400px] flex flex-col gap-[30px] relative p-[20px]">
                            <span className="absolute right-[0px] lg:right-[-40px] top-[-40px] text-8xl text-[#D0A847] font-black">"</span>
                            <h2 className="text-justify">
                                {t('testimonial2')}
                            </h2>
                            <div className="flex items-center gap-[20px]">
                                <img src={seed} className="max-w-[60px]" alt="" />
                                <span>{t('team_seedawi')}</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="px-[10px] lg:px-[100px] 2xl:px-[200px] flex flex-col gap-[100px] py-[50px] flex flex-col lg:flex-row justify-center">
                    <div className="flex flex-col gap-[30px] w-full">
                        <h2 className="is-slideup text-lg lg:text-2xl 2xl:text-4xl">{t('interested_in')}</h2>
                        <h2 className="text-md lg:text-xl 2xl:text-2xl">{t('leave_your_contact_details')}</h2>

                        <div className="flex flex-col w-full gap-[20px]">
                            <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder={t('name')} className="outline-none p-[10px] border-b-[2px] border-b-[#201b57]" />
                            <input value={phone} onChange={(e) => setPhone(e.target.value)} type="text" placeholder={t('phone')} className="outline-none p-[10px] border-b-[2px] border-b-[#201b57]" />
                        </div>

                        <div className="flex justify-end mt-[50px]">
                            <Link onClick={(e) => sendEmails(e)} to='' className="text-white underline underline-offset-[5px] nbg p-[8px] rounded-full px-[20px] text-lg hover:bg-[#D0A847] hover:text-[#201B57] transition-all duration-[.3s]">{t('submit')}</Link>
                        </div>
                    </div>
                    <div className="min-w-full md:min-w-[500px] lg:min-w-[600px]">
                        <img className="w-full lg:w-[600px]" src={seclimg} alt="" />
                    </div>
                </section>
            </div>
        </React.Fragment>
    )
}